import type { TCountry } from "../types/outerLayout/common";
import {
  EG as EGYFlag,
  SA as SAUFlag,
  AE as AREFlag,
  OM as OMNFlag,
  PK as PAKFlag,
  US as USFlag,
  KW as KWFlag
} from '@unified-checkout/design-system/icons/countries';

export const COUNTRIES: { [key in TCountry]: TCountry } = {
  EGY: 'EGY',
  SAU: 'SAU',
  ARE: 'ARE',
  OMN: 'OMN',
  JOR: 'JOR',
  PAK: 'PAK',
};

export const COUNTRIES_INFO = {
  [COUNTRIES.EGY]: {
    phone_number_length: {
      min: 11,
      max: 11
    },
    phone_country_code: "+2",
    country_code: "EGY",
    country_code_iso2: "EG",
    currency: "EGP",
    flag: EGYFlag,
    time_zone: "Africa/Cairo",
    phone_regex: /^01[0125][0-9]{8}$/,
    placeholder: '01234567890'
  },
  [COUNTRIES.SAU]: {
    phone_number_length: {
      min: 9,
      max: 9
    },
    phone_country_code: "+966",
    country_code: "SAU",
    country_code_iso2: "SA",
    currency: "SAR",
    flag: SAUFlag,
    time_zone: "Asia/Riyadh",
    phone_regex: /^[0-9]{9}$/,
    placeholder: '501394947'
  },
  [COUNTRIES.ARE]: {
    phone_number_length: {
      min: 9,
      max: 9
    },
    phone_country_code: "+971",
    country_code: "ARE",
    country_code_iso2: "AE",
    currency: "AED",
    flag: AREFlag,
    time_zone: "Asia/Dubai",
    phone_regex: /^(5)\d{8}$/,
    placeholder: '501394947'
  },
  [COUNTRIES.OMN]: {
    phone_number_length: {
      min: 8,
      max: 10
    },
    phone_country_code: "+968",
    country_code: "OMN",
    country_code_iso2: "OM",
    currency: "OMR",
    flag: OMNFlag,
    time_zone: "Asia/Muscat",
    phone_regex: /^[0-9]{8}$/,
    placeholder: '92139494'
  },
  [COUNTRIES.JOR]: {
    phone_number_length: {
      min: 8,
      max: 9
    },
    phone_country_code: "+962",
    country_code: "JOR",
    country_code_iso2: "JO",
    currency: "JOD",
    flag: OMNFlag,
    time_zone: "Asia/Amman",
    phone_regex: /^[0-9]{5,9}$/,
    placeholder: '791394947'
  },
  [COUNTRIES.PAK]: {
    phone_number_length: {
      min: 10,
      max: 10
    },
    phone_country_code: "+92",
    country_code: "PAK",
    country_code_iso2: "PK",
    currency: "PKR",
    flag: PAKFlag,
    time_zone: "Asia/Karachi",
    phone_regex: /^[0-9]{10}$/,
    placeholder: '3013949476'
  },
  USA: {
    phone_number_length: {
      min: 10,
      max: 10
    },
    phone_country_code: "+1",
    country_code: "USA",
    country_code_iso2: "US",
    currency: "USD",
    flag: USFlag,
    time_zone: "America/New_York",
    phone_regex: /^[0-9]{10}$/,
    placeholder: '2015550123'
  },
  KWT: {
    phone_number_length: {
      min: 8,
      max: 8
    },
    phone_country_code: "+965",
    country_code: "KWT",
    country_code_iso2: "KW",
    currency: "KWD",
    flag: KWFlag,
    time_zone: "Asia/Kuwait",
    phone_regex: /^[0-9]{8}$/,
    placeholder: '50139494'
  }
};